/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CatalogueRouteRouteImport } from './routes/catalogue/route'
import { Route as DesignRouteRouteImport } from './routes/design/route'
import { Route as FoundryRouteRouteImport } from './routes/foundry/route'
import { Route as ImportRouteRouteImport } from './routes/import/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ReferenceRouteRouteImport } from './routes/reference/route'
import { Route as SheetsRouteRouteImport } from './routes/sheets/route'
import { Route as TemplatesRouteRouteImport } from './routes/templates/route'
import { Route as TypesRouteRouteImport } from './routes/types/route'
import { Route as ViewsRouteRouteImport } from './routes/views/route'
import { Route as AboutLicencesRouteImport } from './routes/about/licences'
import { Route as AfterSessionIdRouteImport } from './routes/after/$sessionId'
import { Route as BootstrapIndexRouteImport } from './routes/bootstrap/index'
import { Route as CalendarIndexRouteImport } from './routes/calendar/index'
import { Route as CaptureClipboardIndexRouteImport } from './routes/capture-clipboard/index'
import { Route as CatalogueIndexRouteImport } from './routes/catalogue/index'
import { Route as CatalogueTypeKeyRouteImport } from './routes/catalogue/$typeKey'
import { Route as ChronicleIndexRouteImport } from './routes/chronicle/index'
import { Route as DesignIndexRouteImport } from './routes/design/index'
import { Route as DesignScreenRouteImport } from './routes/design/$screen'
import { Route as DocIdRouteImport } from './routes/doc/$id'
import { Route as FoundryIndexRouteImport } from './routes/foundry/index'
import { Route as FoundryHistoryRouteImport } from './routes/foundry/history'
import { Route as HealthIndexRouteImport } from './routes/health/index'
import { Route as ImportIndexRouteImport } from './routes/import/index'
import { Route as ImportRunIdRouteImport } from './routes/import/$runId'
import { Route as ImportHistoryRouteImport } from './routes/import/history'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ReferenceIndexRouteImport } from './routes/reference/index'
import { Route as ReferenceIdRouteImport } from './routes/reference/$id'
import { Route as RunSessionIdRouteImport } from './routes/run/$sessionId'
import { Route as SecretsIndexRouteImport } from './routes/secrets/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SheetsDocIdRouteImport } from './routes/sheets/$docId'
import { Route as SheetsCardsRouteRouteImport } from './routes/sheets/cards/route'
import { Route as SheetsPcRouteRouteImport } from './routes/sheets/pc/route'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesTypeKeyRouteImport } from './routes/templates/$typeKey'
import { Route as TonightIndexRouteImport } from './routes/tonight/index'
import { Route as TrashIndexRouteImport } from './routes/trash/index'
import { Route as TypesIndexRouteImport } from './routes/types/index'
import { Route as TypesTypeKeyRouteImport } from './routes/types/$typeKey'
import { Route as ViewsIndexRouteImport } from './routes/views/index'
import { Route as ViewsViewIdRouteImport } from './routes/views/$viewId'
import { Route as FoundryImportsImportIdRouteImport } from './routes/foundry/imports/$importId'
import { Route as ReadIdIndexRouteImport } from './routes/read/$id/index'
import { Route as ReadIdTableRouteImport } from './routes/read/$id/table'
import { Route as SheetsCardsDocIdRouteImport } from './routes/sheets/cards/$docId'
import { Route as SheetsPcDocIdRouteImport } from './routes/sheets/pc/$docId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueRouteRoute = CatalogueRouteRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRouteRoute = DesignRouteRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundryRouteRoute = FoundryRouteRouteImport.update({
  id: '/foundry',
  path: '/foundry',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRouteRoute = ImportRouteRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferenceRouteRoute = ReferenceRouteRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetsRouteRoute = SheetsRouteRouteImport.update({
  id: '/sheets',
  path: '/sheets',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRouteRoute = TemplatesRouteRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const TypesRouteRoute = TypesRouteRouteImport.update({
  id: '/types',
  path: '/types',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewsRouteRoute = ViewsRouteRouteImport.update({
  id: '/views',
  path: '/views',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutLicencesRoute = AboutLicencesRouteImport.update({
  id: '/about/licences',
  path: '/about/licences',
  getParentRoute: () => rootRouteImport,
} as any)
const AfterSessionIdRoute = AfterSessionIdRouteImport.update({
  id: '/after/$sessionId',
  path: '/after/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const BootstrapIndexRoute = BootstrapIndexRouteImport.update({
  id: '/bootstrap/',
  path: '/bootstrap/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarIndexRoute = CalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureClipboardIndexRoute = CaptureClipboardIndexRouteImport.update({
  id: '/capture-clipboard/',
  path: '/capture-clipboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueIndexRoute = CatalogueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogueRouteRoute,
} as any)
const CatalogueTypeKeyRoute = CatalogueTypeKeyRouteImport.update({
  id: '/$typeKey',
  path: '/$typeKey',
  getParentRoute: () => CatalogueRouteRoute,
} as any)
const ChronicleIndexRoute = ChronicleIndexRouteImport.update({
  id: '/chronicle/',
  path: '/chronicle/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignIndexRoute = DesignIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesignRouteRoute,
} as any)
const DesignScreenRoute = DesignScreenRouteImport.update({
  id: '/$screen',
  path: '/$screen',
  getParentRoute: () => DesignRouteRoute,
} as any)
const DocIdRoute = DocIdRouteImport.update({
  id: '/doc/$id',
  path: '/doc/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundryIndexRoute = FoundryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoundryRouteRoute,
} as any)
const FoundryHistoryRoute = FoundryHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => FoundryRouteRoute,
} as any)
const HealthIndexRoute = HealthIndexRouteImport.update({
  id: '/health/',
  path: '/health/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportIndexRoute = ImportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ImportRouteRoute,
} as any)
const ImportRunIdRoute = ImportRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => ImportRouteRoute,
} as any)
const ImportHistoryRoute = ImportHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => ImportRouteRoute,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferenceIndexRoute = ReferenceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReferenceRouteRoute,
} as any)
const ReferenceIdRoute = ReferenceIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ReferenceRouteRoute,
} as any)
const RunSessionIdRoute = RunSessionIdRouteImport.update({
  id: '/run/$sessionId',
  path: '/run/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretsIndexRoute = SecretsIndexRouteImport.update({
  id: '/secrets/',
  path: '/secrets/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetsDocIdRoute = SheetsDocIdRouteImport.update({
  id: '/$docId',
  path: '/$docId',
  getParentRoute: () => SheetsRouteRoute,
} as any)
const SheetsCardsRouteRoute = SheetsCardsRouteRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => SheetsRouteRoute,
} as any)
const SheetsPcRouteRoute = SheetsPcRouteRouteImport.update({
  id: '/pc',
  path: '/pc',
  getParentRoute: () => SheetsRouteRoute,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TemplatesRouteRoute,
} as any)
const TemplatesTypeKeyRoute = TemplatesTypeKeyRouteImport.update({
  id: '/$typeKey',
  path: '/$typeKey',
  getParentRoute: () => TemplatesRouteRoute,
} as any)
const TonightIndexRoute = TonightIndexRouteImport.update({
  id: '/tonight/',
  path: '/tonight/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrashIndexRoute = TrashIndexRouteImport.update({
  id: '/trash/',
  path: '/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const TypesIndexRoute = TypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TypesRouteRoute,
} as any)
const TypesTypeKeyRoute = TypesTypeKeyRouteImport.update({
  id: '/$typeKey',
  path: '/$typeKey',
  getParentRoute: () => TypesRouteRoute,
} as any)
const ViewsIndexRoute = ViewsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ViewsRouteRoute,
} as any)
const ViewsViewIdRoute = ViewsViewIdRouteImport.update({
  id: '/$viewId',
  path: '/$viewId',
  getParentRoute: () => ViewsRouteRoute,
} as any)
const FoundryImportsImportIdRoute = FoundryImportsImportIdRouteImport.update({
  id: '/imports/$importId',
  path: '/imports/$importId',
  getParentRoute: () => FoundryRouteRoute,
} as any)
const ReadIdIndexRoute = ReadIdIndexRouteImport.update({
  id: '/read/$id/',
  path: '/read/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadIdTableRoute = ReadIdTableRouteImport.update({
  id: '/read/$id/table',
  path: '/read/$id/table',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetsCardsDocIdRoute = SheetsCardsDocIdRouteImport.update({
  id: '/$docId',
  path: '/$docId',
  getParentRoute: () => SheetsCardsRouteRoute,
} as any)
const SheetsPcDocIdRoute = SheetsPcDocIdRouteImport.update({
  id: '/$docId',
  path: '/$docId',
  getParentRoute: () => SheetsPcRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/catalogue': typeof CatalogueRouteRouteWithChildren
  '/design': typeof DesignRouteRouteWithChildren
  '/foundry': typeof FoundryRouteRouteWithChildren
  '/import': typeof ImportRouteRouteWithChildren
  '/reference': typeof ReferenceRouteRouteWithChildren
  '/sheets': typeof SheetsRouteRouteWithChildren
  '/templates': typeof TemplatesRouteRouteWithChildren
  '/types': typeof TypesRouteRouteWithChildren
  '/views': typeof ViewsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/sheets/cards': typeof SheetsCardsRouteRouteWithChildren
  '/sheets/pc': typeof SheetsPcRouteRouteWithChildren
  '/about/licences': typeof AboutLicencesRoute
  '/after/$sessionId': typeof AfterSessionIdRoute
  '/catalogue/$typeKey': typeof CatalogueTypeKeyRoute
  '/design/$screen': typeof DesignScreenRoute
  '/doc/$id': typeof DocIdRoute
  '/foundry/history': typeof FoundryHistoryRoute
  '/import/$runId': typeof ImportRunIdRoute
  '/import/history': typeof ImportHistoryRoute
  '/reference/$id': typeof ReferenceIdRoute
  '/run/$sessionId': typeof RunSessionIdRoute
  '/sheets/$docId': typeof SheetsDocIdRoute
  '/templates/$typeKey': typeof TemplatesTypeKeyRoute
  '/types/$typeKey': typeof TypesTypeKeyRoute
  '/views/$viewId': typeof ViewsViewIdRoute
  '/bootstrap/': typeof BootstrapIndexRoute
  '/calendar/': typeof CalendarIndexRoute
  '/capture-clipboard/': typeof CaptureClipboardIndexRoute
  '/catalogue/': typeof CatalogueIndexRoute
  '/chronicle/': typeof ChronicleIndexRoute
  '/design/': typeof DesignIndexRoute
  '/foundry/': typeof FoundryIndexRoute
  '/health/': typeof HealthIndexRoute
  '/import/': typeof ImportIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/reference/': typeof ReferenceIndexRoute
  '/secrets/': typeof SecretsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/tonight/': typeof TonightIndexRoute
  '/trash/': typeof TrashIndexRoute
  '/types/': typeof TypesIndexRoute
  '/views/': typeof ViewsIndexRoute
  '/foundry/imports/$importId': typeof FoundryImportsImportIdRoute
  '/read/$id/table': typeof ReadIdTableRoute
  '/sheets/cards/$docId': typeof SheetsCardsDocIdRoute
  '/sheets/pc/$docId': typeof SheetsPcDocIdRoute
  '/read/$id/': typeof ReadIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sheets': typeof SheetsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/sheets/cards': typeof SheetsCardsRouteRouteWithChildren
  '/sheets/pc': typeof SheetsPcRouteRouteWithChildren
  '/about/licences': typeof AboutLicencesRoute
  '/after/$sessionId': typeof AfterSessionIdRoute
  '/catalogue/$typeKey': typeof CatalogueTypeKeyRoute
  '/design/$screen': typeof DesignScreenRoute
  '/doc/$id': typeof DocIdRoute
  '/foundry/history': typeof FoundryHistoryRoute
  '/import/$runId': typeof ImportRunIdRoute
  '/import/history': typeof ImportHistoryRoute
  '/reference/$id': typeof ReferenceIdRoute
  '/run/$sessionId': typeof RunSessionIdRoute
  '/sheets/$docId': typeof SheetsDocIdRoute
  '/templates/$typeKey': typeof TemplatesTypeKeyRoute
  '/types/$typeKey': typeof TypesTypeKeyRoute
  '/views/$viewId': typeof ViewsViewIdRoute
  '/bootstrap': typeof BootstrapIndexRoute
  '/calendar': typeof CalendarIndexRoute
  '/capture-clipboard': typeof CaptureClipboardIndexRoute
  '/catalogue': typeof CatalogueIndexRoute
  '/chronicle': typeof ChronicleIndexRoute
  '/design': typeof DesignIndexRoute
  '/foundry': typeof FoundryIndexRoute
  '/health': typeof HealthIndexRoute
  '/import': typeof ImportIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/reference': typeof ReferenceIndexRoute
  '/secrets': typeof SecretsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/tonight': typeof TonightIndexRoute
  '/trash': typeof TrashIndexRoute
  '/types': typeof TypesIndexRoute
  '/views': typeof ViewsIndexRoute
  '/foundry/imports/$importId': typeof FoundryImportsImportIdRoute
  '/read/$id/table': typeof ReadIdTableRoute
  '/sheets/cards/$docId': typeof SheetsCardsDocIdRoute
  '/sheets/pc/$docId': typeof SheetsPcDocIdRoute
  '/read/$id': typeof ReadIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/catalogue': typeof CatalogueRouteRouteWithChildren
  '/design': typeof DesignRouteRouteWithChildren
  '/foundry': typeof FoundryRouteRouteWithChildren
  '/import': typeof ImportRouteRouteWithChildren
  '/reference': typeof ReferenceRouteRouteWithChildren
  '/sheets': typeof SheetsRouteRouteWithChildren
  '/templates': typeof TemplatesRouteRouteWithChildren
  '/types': typeof TypesRouteRouteWithChildren
  '/views': typeof ViewsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/sheets/cards': typeof SheetsCardsRouteRouteWithChildren
  '/sheets/pc': typeof SheetsPcRouteRouteWithChildren
  '/about/licences': typeof AboutLicencesRoute
  '/after/$sessionId': typeof AfterSessionIdRoute
  '/catalogue/$typeKey': typeof CatalogueTypeKeyRoute
  '/design/$screen': typeof DesignScreenRoute
  '/doc/$id': typeof DocIdRoute
  '/foundry/history': typeof FoundryHistoryRoute
  '/import/$runId': typeof ImportRunIdRoute
  '/import/history': typeof ImportHistoryRoute
  '/reference/$id': typeof ReferenceIdRoute
  '/run/$sessionId': typeof RunSessionIdRoute
  '/sheets/$docId': typeof SheetsDocIdRoute
  '/templates/$typeKey': typeof TemplatesTypeKeyRoute
  '/types/$typeKey': typeof TypesTypeKeyRoute
  '/views/$viewId': typeof ViewsViewIdRoute
  '/bootstrap/': typeof BootstrapIndexRoute
  '/calendar/': typeof CalendarIndexRoute
  '/capture-clipboard/': typeof CaptureClipboardIndexRoute
  '/catalogue/': typeof CatalogueIndexRoute
  '/chronicle/': typeof ChronicleIndexRoute
  '/design/': typeof DesignIndexRoute
  '/foundry/': typeof FoundryIndexRoute
  '/health/': typeof HealthIndexRoute
  '/import/': typeof ImportIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/reference/': typeof ReferenceIndexRoute
  '/secrets/': typeof SecretsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/tonight/': typeof TonightIndexRoute
  '/trash/': typeof TrashIndexRoute
  '/types/': typeof TypesIndexRoute
  '/views/': typeof ViewsIndexRoute
  '/foundry/imports/$importId': typeof FoundryImportsImportIdRoute
  '/read/$id/table': typeof ReadIdTableRoute
  '/sheets/cards/$docId': typeof SheetsCardsDocIdRoute
  '/sheets/pc/$docId': typeof SheetsPcDocIdRoute
  '/read/$id/': typeof ReadIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catalogue'
    | '/design'
    | '/foundry'
    | '/import'
    | '/reference'
    | '/sheets'
    | '/templates'
    | '/types'
    | '/views'
    | '/login'
    | '/sheets/cards'
    | '/sheets/pc'
    | '/about/licences'
    | '/after/$sessionId'
    | '/catalogue/$typeKey'
    | '/design/$screen'
    | '/doc/$id'
    | '/foundry/history'
    | '/import/$runId'
    | '/import/history'
    | '/reference/$id'
    | '/run/$sessionId'
    | '/sheets/$docId'
    | '/templates/$typeKey'
    | '/types/$typeKey'
    | '/views/$viewId'
    | '/bootstrap/'
    | '/calendar/'
    | '/capture-clipboard/'
    | '/catalogue/'
    | '/chronicle/'
    | '/design/'
    | '/foundry/'
    | '/health/'
    | '/import/'
    | '/inbox/'
    | '/reference/'
    | '/secrets/'
    | '/settings/'
    | '/templates/'
    | '/tonight/'
    | '/trash/'
    | '/types/'
    | '/views/'
    | '/foundry/imports/$importId'
    | '/read/$id/table'
    | '/sheets/cards/$docId'
    | '/sheets/pc/$docId'
    | '/read/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sheets'
    | '/login'
    | '/sheets/cards'
    | '/sheets/pc'
    | '/about/licences'
    | '/after/$sessionId'
    | '/catalogue/$typeKey'
    | '/design/$screen'
    | '/doc/$id'
    | '/foundry/history'
    | '/import/$runId'
    | '/import/history'
    | '/reference/$id'
    | '/run/$sessionId'
    | '/sheets/$docId'
    | '/templates/$typeKey'
    | '/types/$typeKey'
    | '/views/$viewId'
    | '/bootstrap'
    | '/calendar'
    | '/capture-clipboard'
    | '/catalogue'
    | '/chronicle'
    | '/design'
    | '/foundry'
    | '/health'
    | '/import'
    | '/inbox'
    | '/reference'
    | '/secrets'
    | '/settings'
    | '/templates'
    | '/tonight'
    | '/trash'
    | '/types'
    | '/views'
    | '/foundry/imports/$importId'
    | '/read/$id/table'
    | '/sheets/cards/$docId'
    | '/sheets/pc/$docId'
    | '/read/$id'
  id:
    | '__root__'
    | '/'
    | '/catalogue'
    | '/design'
    | '/foundry'
    | '/import'
    | '/reference'
    | '/sheets'
    | '/templates'
    | '/types'
    | '/views'
    | '/login'
    | '/sheets/cards'
    | '/sheets/pc'
    | '/about/licences'
    | '/after/$sessionId'
    | '/catalogue/$typeKey'
    | '/design/$screen'
    | '/doc/$id'
    | '/foundry/history'
    | '/import/$runId'
    | '/import/history'
    | '/reference/$id'
    | '/run/$sessionId'
    | '/sheets/$docId'
    | '/templates/$typeKey'
    | '/types/$typeKey'
    | '/views/$viewId'
    | '/bootstrap/'
    | '/calendar/'
    | '/capture-clipboard/'
    | '/catalogue/'
    | '/chronicle/'
    | '/design/'
    | '/foundry/'
    | '/health/'
    | '/import/'
    | '/inbox/'
    | '/reference/'
    | '/secrets/'
    | '/settings/'
    | '/templates/'
    | '/tonight/'
    | '/trash/'
    | '/types/'
    | '/views/'
    | '/foundry/imports/$importId'
    | '/read/$id/table'
    | '/sheets/cards/$docId'
    | '/sheets/pc/$docId'
    | '/read/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CatalogueRouteRoute: typeof CatalogueRouteRouteWithChildren
  DesignRouteRoute: typeof DesignRouteRouteWithChildren
  FoundryRouteRoute: typeof FoundryRouteRouteWithChildren
  ImportRouteRoute: typeof ImportRouteRouteWithChildren
  ReferenceRouteRoute: typeof ReferenceRouteRouteWithChildren
  SheetsRouteRoute: typeof SheetsRouteRouteWithChildren
  TemplatesRouteRoute: typeof TemplatesRouteRouteWithChildren
  TypesRouteRoute: typeof TypesRouteRouteWithChildren
  ViewsRouteRoute: typeof ViewsRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AboutLicencesRoute: typeof AboutLicencesRoute
  AfterSessionIdRoute: typeof AfterSessionIdRoute
  DocIdRoute: typeof DocIdRoute
  RunSessionIdRoute: typeof RunSessionIdRoute
  BootstrapIndexRoute: typeof BootstrapIndexRoute
  CalendarIndexRoute: typeof CalendarIndexRoute
  CaptureClipboardIndexRoute: typeof CaptureClipboardIndexRoute
  ChronicleIndexRoute: typeof ChronicleIndexRoute
  HealthIndexRoute: typeof HealthIndexRoute
  InboxIndexRoute: typeof InboxIndexRoute
  SecretsIndexRoute: typeof SecretsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TonightIndexRoute: typeof TonightIndexRoute
  TrashIndexRoute: typeof TrashIndexRoute
  ReadIdTableRoute: typeof ReadIdTableRoute
  ReadIdIndexRoute: typeof ReadIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue': {
      id: '/catalogue'
      path: '/catalogue'
      fullPath: '/catalogue'
      preLoaderRoute: typeof CatalogueRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/foundry': {
      id: '/foundry'
      path: '/foundry'
      fullPath: '/foundry'
      preLoaderRoute: typeof FoundryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference': {
      id: '/reference'
      path: '/reference'
      fullPath: '/reference'
      preLoaderRoute: typeof ReferenceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheets': {
      id: '/sheets'
      path: '/sheets'
      fullPath: '/sheets'
      preLoaderRoute: typeof SheetsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/types': {
      id: '/types'
      path: '/types'
      fullPath: '/types'
      preLoaderRoute: typeof TypesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/views': {
      id: '/views'
      path: '/views'
      fullPath: '/views'
      preLoaderRoute: typeof ViewsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/licences': {
      id: '/about/licences'
      path: '/about/licences'
      fullPath: '/about/licences'
      preLoaderRoute: typeof AboutLicencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/after/$sessionId': {
      id: '/after/$sessionId'
      path: '/after/$sessionId'
      fullPath: '/after/$sessionId'
      preLoaderRoute: typeof AfterSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bootstrap/': {
      id: '/bootstrap/'
      path: '/bootstrap'
      fullPath: '/bootstrap/'
      preLoaderRoute: typeof BootstrapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar/': {
      id: '/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof CalendarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture-clipboard/': {
      id: '/capture-clipboard/'
      path: '/capture-clipboard'
      fullPath: '/capture-clipboard/'
      preLoaderRoute: typeof CaptureClipboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/': {
      id: '/catalogue/'
      path: '/'
      fullPath: '/catalogue/'
      preLoaderRoute: typeof CatalogueIndexRouteImport
      parentRoute: typeof CatalogueRouteRoute
    }
    '/catalogue/$typeKey': {
      id: '/catalogue/$typeKey'
      path: '/$typeKey'
      fullPath: '/catalogue/$typeKey'
      preLoaderRoute: typeof CatalogueTypeKeyRouteImport
      parentRoute: typeof CatalogueRouteRoute
    }
    '/chronicle/': {
      id: '/chronicle/'
      path: '/chronicle'
      fullPath: '/chronicle/'
      preLoaderRoute: typeof ChronicleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design/': {
      id: '/design/'
      path: '/'
      fullPath: '/design/'
      preLoaderRoute: typeof DesignIndexRouteImport
      parentRoute: typeof DesignRouteRoute
    }
    '/design/$screen': {
      id: '/design/$screen'
      path: '/$screen'
      fullPath: '/design/$screen'
      preLoaderRoute: typeof DesignScreenRouteImport
      parentRoute: typeof DesignRouteRoute
    }
    '/doc/$id': {
      id: '/doc/$id'
      path: '/doc/$id'
      fullPath: '/doc/$id'
      preLoaderRoute: typeof DocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/foundry/': {
      id: '/foundry/'
      path: '/'
      fullPath: '/foundry/'
      preLoaderRoute: typeof FoundryIndexRouteImport
      parentRoute: typeof FoundryRouteRoute
    }
    '/foundry/history': {
      id: '/foundry/history'
      path: '/history'
      fullPath: '/foundry/history'
      preLoaderRoute: typeof FoundryHistoryRouteImport
      parentRoute: typeof FoundryRouteRoute
    }
    '/health/': {
      id: '/health/'
      path: '/health'
      fullPath: '/health/'
      preLoaderRoute: typeof HealthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/': {
      id: '/import/'
      path: '/'
      fullPath: '/import/'
      preLoaderRoute: typeof ImportIndexRouteImport
      parentRoute: typeof ImportRouteRoute
    }
    '/import/$runId': {
      id: '/import/$runId'
      path: '/$runId'
      fullPath: '/import/$runId'
      preLoaderRoute: typeof ImportRunIdRouteImport
      parentRoute: typeof ImportRouteRoute
    }
    '/import/history': {
      id: '/import/history'
      path: '/history'
      fullPath: '/import/history'
      preLoaderRoute: typeof ImportHistoryRouteImport
      parentRoute: typeof ImportRouteRoute
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference/': {
      id: '/reference/'
      path: '/'
      fullPath: '/reference/'
      preLoaderRoute: typeof ReferenceIndexRouteImport
      parentRoute: typeof ReferenceRouteRoute
    }
    '/reference/$id': {
      id: '/reference/$id'
      path: '/$id'
      fullPath: '/reference/$id'
      preLoaderRoute: typeof ReferenceIdRouteImport
      parentRoute: typeof ReferenceRouteRoute
    }
    '/run/$sessionId': {
      id: '/run/$sessionId'
      path: '/run/$sessionId'
      fullPath: '/run/$sessionId'
      preLoaderRoute: typeof RunSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secrets/': {
      id: '/secrets/'
      path: '/secrets'
      fullPath: '/secrets/'
      preLoaderRoute: typeof SecretsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheets/$docId': {
      id: '/sheets/$docId'
      path: '/$docId'
      fullPath: '/sheets/$docId'
      preLoaderRoute: typeof SheetsDocIdRouteImport
      parentRoute: typeof SheetsRouteRoute
    }
    '/sheets/cards': {
      id: '/sheets/cards'
      path: '/cards'
      fullPath: '/sheets/cards'
      preLoaderRoute: typeof SheetsCardsRouteRouteImport
      parentRoute: typeof SheetsRouteRoute
    }
    '/sheets/pc': {
      id: '/sheets/pc'
      path: '/pc'
      fullPath: '/sheets/pc'
      preLoaderRoute: typeof SheetsPcRouteRouteImport
      parentRoute: typeof SheetsRouteRoute
    }
    '/templates/': {
      id: '/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof TemplatesRouteRoute
    }
    '/templates/$typeKey': {
      id: '/templates/$typeKey'
      path: '/$typeKey'
      fullPath: '/templates/$typeKey'
      preLoaderRoute: typeof TemplatesTypeKeyRouteImport
      parentRoute: typeof TemplatesRouteRoute
    }
    '/tonight/': {
      id: '/tonight/'
      path: '/tonight'
      fullPath: '/tonight/'
      preLoaderRoute: typeof TonightIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trash/': {
      id: '/trash/'
      path: '/trash'
      fullPath: '/trash/'
      preLoaderRoute: typeof TrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/types/': {
      id: '/types/'
      path: '/'
      fullPath: '/types/'
      preLoaderRoute: typeof TypesIndexRouteImport
      parentRoute: typeof TypesRouteRoute
    }
    '/types/$typeKey': {
      id: '/types/$typeKey'
      path: '/$typeKey'
      fullPath: '/types/$typeKey'
      preLoaderRoute: typeof TypesTypeKeyRouteImport
      parentRoute: typeof TypesRouteRoute
    }
    '/views/': {
      id: '/views/'
      path: '/'
      fullPath: '/views/'
      preLoaderRoute: typeof ViewsIndexRouteImport
      parentRoute: typeof ViewsRouteRoute
    }
    '/views/$viewId': {
      id: '/views/$viewId'
      path: '/$viewId'
      fullPath: '/views/$viewId'
      preLoaderRoute: typeof ViewsViewIdRouteImport
      parentRoute: typeof ViewsRouteRoute
    }
    '/foundry/imports/$importId': {
      id: '/foundry/imports/$importId'
      path: '/imports/$importId'
      fullPath: '/foundry/imports/$importId'
      preLoaderRoute: typeof FoundryImportsImportIdRouteImport
      parentRoute: typeof FoundryRouteRoute
    }
    '/read/$id/': {
      id: '/read/$id/'
      path: '/read/$id'
      fullPath: '/read/$id/'
      preLoaderRoute: typeof ReadIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$id/table': {
      id: '/read/$id/table'
      path: '/read/$id/table'
      fullPath: '/read/$id/table'
      preLoaderRoute: typeof ReadIdTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheets/cards/$docId': {
      id: '/sheets/cards/$docId'
      path: '/$docId'
      fullPath: '/sheets/cards/$docId'
      preLoaderRoute: typeof SheetsCardsDocIdRouteImport
      parentRoute: typeof SheetsCardsRouteRoute
    }
    '/sheets/pc/$docId': {
      id: '/sheets/pc/$docId'
      path: '/$docId'
      fullPath: '/sheets/pc/$docId'
      preLoaderRoute: typeof SheetsPcDocIdRouteImport
      parentRoute: typeof SheetsPcRouteRoute
    }
  }
}

interface CatalogueRouteRouteChildren {
  CatalogueTypeKeyRoute: typeof CatalogueTypeKeyRoute
  CatalogueIndexRoute: typeof CatalogueIndexRoute
}

const CatalogueRouteRouteChildren: CatalogueRouteRouteChildren = {
  CatalogueTypeKeyRoute: CatalogueTypeKeyRoute,
  CatalogueIndexRoute: CatalogueIndexRoute,
}

const CatalogueRouteRouteWithChildren = CatalogueRouteRoute._addFileChildren(
  CatalogueRouteRouteChildren,
)

interface DesignRouteRouteChildren {
  DesignScreenRoute: typeof DesignScreenRoute
  DesignIndexRoute: typeof DesignIndexRoute
}

const DesignRouteRouteChildren: DesignRouteRouteChildren = {
  DesignScreenRoute: DesignScreenRoute,
  DesignIndexRoute: DesignIndexRoute,
}

const DesignRouteRouteWithChildren = DesignRouteRoute._addFileChildren(
  DesignRouteRouteChildren,
)

interface FoundryRouteRouteChildren {
  FoundryHistoryRoute: typeof FoundryHistoryRoute
  FoundryIndexRoute: typeof FoundryIndexRoute
  FoundryImportsImportIdRoute: typeof FoundryImportsImportIdRoute
}

const FoundryRouteRouteChildren: FoundryRouteRouteChildren = {
  FoundryHistoryRoute: FoundryHistoryRoute,
  FoundryIndexRoute: FoundryIndexRoute,
  FoundryImportsImportIdRoute: FoundryImportsImportIdRoute,
}

const FoundryRouteRouteWithChildren = FoundryRouteRoute._addFileChildren(
  FoundryRouteRouteChildren,
)

interface ImportRouteRouteChildren {
  ImportRunIdRoute: typeof ImportRunIdRoute
  ImportHistoryRoute: typeof ImportHistoryRoute
  ImportIndexRoute: typeof ImportIndexRoute
}

const ImportRouteRouteChildren: ImportRouteRouteChildren = {
  ImportRunIdRoute: ImportRunIdRoute,
  ImportHistoryRoute: ImportHistoryRoute,
  ImportIndexRoute: ImportIndexRoute,
}

const ImportRouteRouteWithChildren = ImportRouteRoute._addFileChildren(
  ImportRouteRouteChildren,
)

interface ReferenceRouteRouteChildren {
  ReferenceIdRoute: typeof ReferenceIdRoute
  ReferenceIndexRoute: typeof ReferenceIndexRoute
}

const ReferenceRouteRouteChildren: ReferenceRouteRouteChildren = {
  ReferenceIdRoute: ReferenceIdRoute,
  ReferenceIndexRoute: ReferenceIndexRoute,
}

const ReferenceRouteRouteWithChildren = ReferenceRouteRoute._addFileChildren(
  ReferenceRouteRouteChildren,
)

interface SheetsCardsRouteRouteChildren {
  SheetsCardsDocIdRoute: typeof SheetsCardsDocIdRoute
}

const SheetsCardsRouteRouteChildren: SheetsCardsRouteRouteChildren = {
  SheetsCardsDocIdRoute: SheetsCardsDocIdRoute,
}

const SheetsCardsRouteRouteWithChildren =
  SheetsCardsRouteRoute._addFileChildren(SheetsCardsRouteRouteChildren)

interface SheetsPcRouteRouteChildren {
  SheetsPcDocIdRoute: typeof SheetsPcDocIdRoute
}

const SheetsPcRouteRouteChildren: SheetsPcRouteRouteChildren = {
  SheetsPcDocIdRoute: SheetsPcDocIdRoute,
}

const SheetsPcRouteRouteWithChildren = SheetsPcRouteRoute._addFileChildren(
  SheetsPcRouteRouteChildren,
)

interface SheetsRouteRouteChildren {
  SheetsCardsRouteRoute: typeof SheetsCardsRouteRouteWithChildren
  SheetsPcRouteRoute: typeof SheetsPcRouteRouteWithChildren
  SheetsDocIdRoute: typeof SheetsDocIdRoute
}

const SheetsRouteRouteChildren: SheetsRouteRouteChildren = {
  SheetsCardsRouteRoute: SheetsCardsRouteRouteWithChildren,
  SheetsPcRouteRoute: SheetsPcRouteRouteWithChildren,
  SheetsDocIdRoute: SheetsDocIdRoute,
}

const SheetsRouteRouteWithChildren = SheetsRouteRoute._addFileChildren(
  SheetsRouteRouteChildren,
)

interface TemplatesRouteRouteChildren {
  TemplatesTypeKeyRoute: typeof TemplatesTypeKeyRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

const TemplatesRouteRouteChildren: TemplatesRouteRouteChildren = {
  TemplatesTypeKeyRoute: TemplatesTypeKeyRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
}

const TemplatesRouteRouteWithChildren = TemplatesRouteRoute._addFileChildren(
  TemplatesRouteRouteChildren,
)

interface TypesRouteRouteChildren {
  TypesTypeKeyRoute: typeof TypesTypeKeyRoute
  TypesIndexRoute: typeof TypesIndexRoute
}

const TypesRouteRouteChildren: TypesRouteRouteChildren = {
  TypesTypeKeyRoute: TypesTypeKeyRoute,
  TypesIndexRoute: TypesIndexRoute,
}

const TypesRouteRouteWithChildren = TypesRouteRoute._addFileChildren(
  TypesRouteRouteChildren,
)

interface ViewsRouteRouteChildren {
  ViewsViewIdRoute: typeof ViewsViewIdRoute
  ViewsIndexRoute: typeof ViewsIndexRoute
}

const ViewsRouteRouteChildren: ViewsRouteRouteChildren = {
  ViewsViewIdRoute: ViewsViewIdRoute,
  ViewsIndexRoute: ViewsIndexRoute,
}

const ViewsRouteRouteWithChildren = ViewsRouteRoute._addFileChildren(
  ViewsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CatalogueRouteRoute: CatalogueRouteRouteWithChildren,
  DesignRouteRoute: DesignRouteRouteWithChildren,
  FoundryRouteRoute: FoundryRouteRouteWithChildren,
  ImportRouteRoute: ImportRouteRouteWithChildren,
  ReferenceRouteRoute: ReferenceRouteRouteWithChildren,
  SheetsRouteRoute: SheetsRouteRouteWithChildren,
  TemplatesRouteRoute: TemplatesRouteRouteWithChildren,
  TypesRouteRoute: TypesRouteRouteWithChildren,
  ViewsRouteRoute: ViewsRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AboutLicencesRoute: AboutLicencesRoute,
  AfterSessionIdRoute: AfterSessionIdRoute,
  DocIdRoute: DocIdRoute,
  RunSessionIdRoute: RunSessionIdRoute,
  BootstrapIndexRoute: BootstrapIndexRoute,
  CalendarIndexRoute: CalendarIndexRoute,
  CaptureClipboardIndexRoute: CaptureClipboardIndexRoute,
  ChronicleIndexRoute: ChronicleIndexRoute,
  HealthIndexRoute: HealthIndexRoute,
  InboxIndexRoute: InboxIndexRoute,
  SecretsIndexRoute: SecretsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TonightIndexRoute: TonightIndexRoute,
  TrashIndexRoute: TrashIndexRoute,
  ReadIdTableRoute: ReadIdTableRoute,
  ReadIdIndexRoute: ReadIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
